export default __webpack_public_path__ + "static/media/ic-facebook-dark.7e5b1631.svg";